const caseYellow = {
  chapterNumber: 1,
  moduleName: "분수의 탄생",
  colorIndex: 0,
  lessons: [
    { lessonName: "생활 속의 분수 이야기", pageCount: null },
    { lessonName: "분수의 세계 맛보기", pageCount: null },
    { lessonName: "1/3, 3개 있으면 1이 되는 수", pageCount: null },
    { lessonName: "2/3는 2개, 1/3이", pageCount: null },
    { lessonName: "분수의 두 얼굴 그리고 이름들", pageCount: null },
    { lessonName: "분수에도 숨어 있는 1", pageCount: null },
    { lessonName: "4분의 3, 4개로 나눈 것 중에서 3개", pageCount: null },
    { lessonName: "2 나누기 3, 2 대 3, 2/3", pageCount: null }
  ]
};
const caseGreen = {
  chapterNumber: 2,
  moduleName: "나누기 상식",
  colorIndex: 1,
  lessons: [
    { lessonName: "나누기는 압축", pageCount: null },
    { lessonName: "나누고 나누면 곱해서 한 번에 나눠라", pageCount: null },
    { lessonName: "곱하기 나누기 순서 내 맘대로", pageCount: null },
    { lessonName: "나누기 앞뒤 가지고 놀기", pageCount: null },
    { lessonName: "나누는 수를 3으로 나눠라? 3배네", pageCount: null },
    { lessonName: "112 ÷ 4, 직사각형 붙이거나 떼거나", pageCount: null },
    { lessonName: "나누기, 큰 것부터 나눠줘라", pageCount: null },
    { lessonName: "나눌 수 없다? 깨뜨려라", pageCount: null }
  ]
};
const caseRed = {
  chapterNumber: 9,
  moduleName: "삼각형의 넓이",
  colorIndex: 2,
  lessons: [
    { lessonName: "분수의 크기 비교, 분자가 같아도 쉽네", pageCount: null },
    { lessonName: "분수 비교, 매개체를 이용하라", pageCount: null },
    { lessonName: "분수를 더하라? 단위를 맞춰라!", pageCount: null }
  ]
};
const MODULE_SUMMARY_CASES = {
  caseYellow,
  caseGreen,
  caseRed
};
export {
  MODULE_SUMMARY_CASES,
  caseGreen,
  caseRed,
  caseYellow
};
//# sourceMappingURL=module-summary-cases.js.map
